import {client as clientAxios} from "@src/library/axios.library";
import {AxiosResponse} from "axios";
import {ShipmentMethodListRequest, ShipmentMethodType} from "@shipment/types/shipmentMethod.types";

export const findList = async (requestBody?: ShipmentMethodListRequest): Promise<ShipmentMethodType[]> => {
    const {data} = await clientAxios
        .post<ShipmentMethodListRequest, AxiosResponse<ShipmentMethodType[]>>('/api/v1/shipment-method', requestBody);
    return data;
}